import React from 'react';
import JourneyMap from 'modules/journey/map/Map';
import { useJsApiLoader } from '@react-google-maps/api';

export const JourneyMapWrapper = (props) => {
  const { isLoaded } = useJsApiLoader({
    id: 'routing-map-google-maps',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  });

  if (!isLoaded) {
    return null;
  }

  return <JourneyMap {...props} />;
};
